export enum TopWinsDateRange {
  Today = 'today',
  ThisWeek = 'thisWeek',
  ThisMonth = 'thisMonth',
  AllTime = 'allTime',
}

export enum TopWinsOrderType {
  WinAmount = 1,
  BetAmount,
  Odd,
}
